import { FooterLinks } from './FooterLinks';
import { Copyright } from './Copyright';

export interface FooterProps {
    onAboutClick: () => void;
    onContactClick: () => void;
}

export function Footer({ onAboutClick, onContactClick }: FooterProps) {
    return (
        <footer className="bg-bg-gray mt-auto">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <FooterLinks onAboutClick={onAboutClick} onContactClick={onContactClick} />
                <Copyright />
            </div>
        </footer>
    );
}
